import React from "react";

class Apropos extends React.Component {
      
    render() {
        return (
            <div>
                
            <div className="block-partenaires-mid height-apropos">
                <h3 className="contain-partenaires-mid"> {this.props.lieux}</h3>
                <p className="contain-partenaires-mid">{this.props.nom}</p>
                <p className="contain-partenaires-mid center-fonction">{this.props.fonction}</p>
            </div>

            </div>


        )
    }
}

export default Apropos;
